import { createContext, useContext, useMemo, useState } from "react"

import {useDeliveryApiNew, useDeliveryStateNew, useDeliveryLogicNew} from '../pages/secure/DeliveryNew'

const ModalContextProvider =  createContext(false)

export const useModalContext = () => useContext(ModalContextProvider)

const ACTIONS = {
    UPDATE: 'UPDATE_GENERIC'
};

export const initialState = {
    orderProgressTab: true,
    orderFinishedTab:false,
    isloading:true,
    listOrderFinished:[],
    listOrdersStatus: [],
    filterStatus:[],
    showFilterModal: false,
    makeDelivery: false,
    disabledCancel: false,
    disabled: false,
    search: '',
    statusCard: 0,
    variantCancelPosition: 0,
    variantPosition: 0,
    stablishmentStatus: false,
    withdraw: 'N',
    isLoadingFinish: false,
    isOpenDeliveryGuy: false,
    filterOptions:[
        {
            option: 'Aguardando Confimação',
            filterId: 1,
            active: false,
            istatus: 1
        },
        {
            option: 'Saiu para Entrega',
            filterId: 2,
            active: false,
            istatus: 4
            
        },
        {
            option: 'Em Preparo',
            filterId: 3,
            active: false,
            istatus: 9
        }
    ]

}

export const storeDeliveryNew = (state, action) => {
    switch (action.type) {
        case ACTIONS.UPDATE:
            return {
                ...state, ...action.payload
            }   
        case 'RESET':
            return initialState; 
        default:
            return state;
    }
}

export const ModalContext = ({children}) => {
    const [isOPen, setIsOPen] = useState(false);

    const state = useDeliveryStateNew()
    const logic = useDeliveryLogicNew(state)
    const api = useDeliveryApiNew(state, logic)

    const contexteValues = useMemo(() => ({
        state,
        logic,
        api,
        setIsOPen,
        isOPen,
    }), [state, isOPen])


    return (
        <ModalContextProvider.Provider value={contexteValues}>
            {children}
        </ModalContextProvider.Provider>

    )



}